import React from "react";
import {
  List,
  Datagrid,
  TextField,
  NumberField,
  BooleanField,
  ArrayField,
  FunctionField,
  CardActions,
  EditButton,
  CreateButton,
  Filter,
  SelectField,
  SingleFieldList,
  translate,
} from "react-admin";
import { withStyles } from "@material-ui/core/styles";
import EditIcon from "../../icon/IcnEdit";
import RuleDeleteButton from "./RuleDeleteButton";
import CreateIcon from "../../icon/IcnOperateAdd";

const styles = (theme) => ({
  hiddenHeader: {
    display: "none",
    height: "0",
  },
});

const RuleFilter = (props) => <Filter {...props}></Filter>;

const RuleActions = ({
  bulkActions,
  basePath,
  currentSort,
  displayedFilters,
  exporter,
  filters,
  filterValues,
  onUnselectItems,
  resource,
  selectedIds,
  showFilter,
}) => (
  <CardActions>
    {bulkActions &&
      React.cloneElement(bulkActions, {
        basePath,
        filterValues,
        resource,
        selectedIds,
        onUnselectItems,
      })}
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: "button",
      })}
    <CreateButton basePath={basePath} icon={<CreateIcon />} />
  </CardActions>
);

const RuleList = ({ classes, translate, ...props }) => (
  <List
    {...props}
    bulkActionButtons={false}
    actions={<RuleActions />}
    filters={<RuleFilter />}
  >
    <Datagrid>
      <TextField source="name" />
      <SelectField
        source="checkinMode"
        choices={[
          { id: 0, name: "resources.operation-rules.enums.checkinMode.button" },
          { id: 1, name: "resources.operation-rules.enums.checkinMode.code" },
        ]}
        sortable={false}
      />
      <BooleanField source="isCancelEnabled" sortable={false} />
      <CancelTimeoutField {...props} source="cancelTimeout" sortable={false} />
      <ArrayField source="reminderTimings" sortable={false}>
        <SingleFieldList linkType={false}>
          <FunctionField
            label="reminder"
            render={(record) =>
              `${record.time}` +
              `${translate(
                "resources.operation-rules.enums.reminderTimeUnit." +
                  record.unit
              )}, `
            }
          />
        </SingleFieldList>
      </ArrayField>
      <BooleanField source="isImmediateUseEnabled" sortable={false} />
      <ImmediateUsePeriodField source="immediateUsePeriod" sortable={false} />
      <BooleanField source="isExtendEnabled" sortable={false} />
      <ExtendPeriodField source="extendPeriod" sortable={false} />
      <BooleanField source="isUserCountEnabled" sortable={false} />
      <BooleanField source="isIncognito" sortable={false} />
      <BooleanField source="isDefault" sortable={false} />
      <EditButton icon={<EditIcon />} />
      <RuleDeleteButton {...props} />
    </Datagrid>
  </List>
);

const CancelTimeoutField = ({ record, ...props }) =>
  record && record.isCancelEnabled ? (
    <NumberField source="cancelTimeout" record={record} {...props} />
  ) : null;
const ImmediateUsePeriodField = ({ record, ...props }) =>
  record && record.isImmediateUseEnabled ? (
    <NumberField source="immediateUsePeriod" record={record} {...props} />
  ) : null;
const ExtendPeriodField = ({ record, ...props }) =>
  record && record.isExtendEnabled ? (
    <NumberField source="extendPeriod" record={record} {...props} />
  ) : null;

export default translate(withStyles(styles)(RuleList));
